<div class="chat-container">
  <div class="chat-header">
    <h2>AI Assistant</h2>
  </div>

  <div class="chat-messages" #chatMessages>
    <div *ngFor="let message of messages" 
         [ngClass]="{'user-message': message.isUser, 'ai-message': !message.isUser}" 
         class="message">
      <div class="message-content">
        <div class="message-text">{{ message.text }}</div>
        <div class="message-time">{{ message.timestamp | date:'shortTime' }}</div>
      </div>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="loading$ | async" class="loading-indicator">
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
      <span>AI is thinking...</span>
    </div>
  </div>

  <div class="chat-input">
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()">
      <mat-form-field appearance="outline" class="message-input">
        <input matInput 
               formControlName="message" 
               placeholder="Type your message..." 
               autocomplete="off">
      </mat-form-field>
      <button mat-flat-button 
              color="primary" 
              type="submit" 
              [disabled]="chatForm.invalid">
        Send
      </button>
    </form>
  </div>
</div>
